// import styled from 'styled-components';
// // import {FaFacebook,FaInstagram,FaTwitter} from 'react-icons/fa'
// import Input from './components/Input';

// function App() {
//  return(

//  <MainContainer>
//   <Welcome>Welcome!</Welcome>
//   <InputStyle>
//  <Input type="text" placeholder="Enter Email"/>
//  <Input type="password" placeholder="Enter Password"/>
//   </InputStyle>
//  </MainContainer>
//  ); 
// }

// const MainContainer = styled.div`

// display : flex;
// align-item : center;
// flex-direction : column;
// height : 80vh;
// width : 30vw; 
// background : rgba(255,255,255,0.3);
// box-shadow : 0 8px 32px 0 rgba(31,38,135,0.4);
// backdrop-filter : blur(5.5px);
// border-radius : 10px;
// color : white;
// text-transfrom : uppercase;
// letter-spacing : 0.4rem;
// `;


// const Welcome = styled.h2`
// margin : 3rem 0 0rem 5.4rem;
// `;

// const InputStyle = styled.div`
// display : flex;
// flex-direction : column;
// justify-content : space-around;
// align-items : center;
// height : 20%;
// width : 100%;

// `;

// export default App;



// import { Button } from "@mui/  material";
import { createTheme, textFieldClasses, ThemeProvider } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import { Add } from "./Dashboard/Add";
import { Feed } from "./Dashboard/Feed";
import { Navbar } from "./Dashboard/Navbar";
import { Rightbar } from "./Dashboard/Rightbar";
import { Sidebar } from "./Dashboard/Sidebar";
// import LoginPage from "./components/LoginPage/LoginPage";
// import Chart from "./components/Chart/Chart";
// import Login from "./components/LoginPage/LoginPage";

function App() {
  const [mode,setMode] = useState("light");

 const darkTheme = createTheme({
  palette : {
    mode : mode,
  },
 });

  return (

 <ThemeProvider theme = {darkTheme}>

    <Box bgcolor={"background.default"} color = {"text.primary"}>
        {/* <Chart/>
        <Login/>
        <LoginPage/> */}
  <Navbar>  </Navbar>
<Stack direction="row" spacing={2} justifyContent="space-evenly"> 

       <Sidebar setMode={setMode} mode={mode}/>
       <Feed/>
       <Rightbar/>
       </Stack>
       <Add/>
    </Box>
    </ThemeProvider>
  );
}

export default App;